import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { triangle } from 'polished';
import { Box, Text } from 'roo-ui/components';
import { position, themeGet } from 'styled-system';
import { getPayWithToggleMessage } from 'store/campaign/campaignSelectors';

const pointerWidth = '10px';

const Message = styled(Box)`
  ${position};
  white-space: nowrap;
  border-radius: ${themeGet('radii.default')};
  background-color: ${themeGet('colors.ui.info')};
  padding: ${themeGet('space.1')} ${themeGet('space.4')};
  &:after {
    content: '';
    position: absolute;
    ${({ pointingDirection, pointerPosition, theme }) => css`
      ${triangle({ pointingDirection, width: pointerWidth, height: pointerWidth, foregroundColor: theme.colors.ui.info })}
      top: ${{
        top: `calc(0% - ${pointerWidth})`,
        bottom: `100%`,
        left: `calc(${pointerPosition} - ${pointerWidth} / 2)`,
        right: `calc(${pointerPosition} - ${pointerWidth} / 2)`,
      }[pointingDirection]};
      left: ${{
        top: `calc(${pointerPosition} - ${pointerWidth} / 2)`,
        bottom: `calc(${pointerPosition} - ${pointerWidth} / 2)`,
        left: `calc(0% - ${pointerWidth})`,
        right: `100%`,
      }[pointingDirection]};
    `}
  }
`;

Message.defaultProps = {
  position: 'relative',
};

const PayWithToggleMessage = ({ pointingDirection, pointerPosition, ...rest }) => {
  const payWithToggleMessage = useSelector(getPayWithToggleMessage);

  return payWithToggleMessage ? (
    <Message pointingDirection={pointingDirection} pointerPosition={pointerPosition} {...rest}>
      <Text fontSize="sm">{payWithToggleMessage}</Text>
    </Message>
  ) : null;
};

// inherited the pointinDirection prop from polished triangle helper. Not the most intuitive values but consistent at least
PayWithToggleMessage.propTypes = {
  pointingDirection: PropTypes.oneOf(['top', 'bottom', 'left', 'right']).isRequired,
  pointerPosition: PropTypes.string,
};

PayWithToggleMessage.defaultProps = {
  pointerPosition: '50%',
};

export default PayWithToggleMessage;
